// Entry point for the build script in your package.json
import "./globals"
import "./controllers"
import "./global_alerts"
import "./flatpickr_dates"
import { initDeleteHandler } from "./delete_handler"
import { initMembers } from "./members"   // <-- Add this line
import "./auth_toggles"
import "./groups"
import "./contribution_types"
import "./contributions"
import "./projects"
import "./materials"
import "./machines"
import "./material_evaluations"
import "./production_costs"
import "./project_approvals"

// Initialize the delete handler to manage deletion links with confirmation and CSRF protection
initDeleteHandler()

// Initialize members offcanvas + form submission
initMembers()
